import {Action} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {EntityDocumento} from './entity-documento.model';
import * as Actions from './entity-documento.actions';
import {ActionsExample, entityReducer, initial} from '~utils/ngrx-util';

export const entityDocumentosFeatureKey = 'entityDocumentos';

export interface State extends EntityState<EntityDocumento> {
}

export const adapter: EntityAdapter<EntityDocumento> = createEntityAdapter<EntityDocumento>();

export const initialState: State = adapter.getInitialState(initial);

const entityActions: ActionsExample<EntityDocumento> = {
  add: Actions.addEntityDocumento,
  adds: Actions.addEntityDocumentos,
  clear: Actions.clearEntityDocumentos,
  remove: Actions.deleteEntityDocumento,
  removes: Actions.deleteEntityDocumentos,
  load: Actions.loadEntityDocumentos,
  update: Actions.updateEntityDocumento,
  updates: Actions.updateEntityDocumentos,
  upsert: Actions.upsertEntityDocumento,
  upserts: Actions.upsertEntityDocumentos,
};

const entityDocumentoReducer = entityReducer(initialState, entityActions, adapter);

export function reducer(state: State | undefined, action: Action): State {
  return entityDocumentoReducer(state, action);
}

export const {selectIds, selectEntities, selectAll, selectTotal} = adapter.getSelectors();
